import React, { useState, useEffect } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

const TtsButton = ({ text }) => {
    const [textToPlay, setTextToPlay] = useState();
    const [utt, setUtt] = useState();
    const [isSpeaking, setIsSpeaking] = useState(false);
    const [started, setStarted] = useState(false);
    const [isPaused, setIsPaused] = useState(false);
    const [isAbleToSpeak, setIsAbleToSpeak] = useState();

    useEffect(() => {
        if (isAbleToSpeak === undefined)
            setIsAbleToSpeak(document.querySelector('body')?.classList.contains('speechSynthesis'));
    }, [isAbleToSpeak]);

    useEffect(() => {
        const onEnd = () => {
            setIsPaused(false);
            setStarted(false);

            if (textToPlay?.length > 0 && !isPaused) {
                utt.text = textToPlay.splice(0, 1);
                speechSynthesis.speak(utt);
                setTextToPlay(textToPlay);
                setIsSpeaking(true);
            } else {
                setIsSpeaking(false);
            }
        };

        const onError = e => {
            console.error(e);
            alert(e);
        };

        const onStart = () => setStarted(true);

        if (!utt) {
            setUtt(new SpeechSynthesisUtterance());
        } else {
            utt.addEventListener('end', onEnd);
            utt.addEventListener('start', onStart);
            utt.addEventListener('error', onError)
        }

        return () => {
            if (utt) {
                utt.removeEventListener('end', onEnd);
                utt.removeEventListener('start', onStart);
                utt.removeEventListener('error', onError);
            }
        }

    }, [utt, textToPlay, isPaused, isSpeaking]);

    const Icon = () => {
        let cssClass;
        let icon = 'play';

        if (isSpeaking) {
            icon = 'stop';
        } else if (isSpeaking && !started) {
            icon = 'atom'
            cssClass = 'fa-spin';
        }

        return <FontAwesomeIcon icon={icon} size="lg" className={cssClass} style={{ marginLeft: '.25em' }} />;
    }

    const toggleSpeaking = () => {
        try {
            if (!isSpeaking) {
                const ttp = text
                    .replace(/&amp;/g, 'und')
                    .replace(/<\/?[\sa-zA-Z0-9="%-/_:#,.@;]{0,}>/g, ' ')
                    .replace(/(^\s*)|(\s*$)/gi, '')
                    .replace(/&ouml;|&Ouml;/g, 'ö')
                    .replace(/&uuml;|&Uuml;/g, 'ü')
                    .replace(/&auml;|&Auml;/g, 'ä')
                    .replace(/&nbsp;/g, ' ')
                    .replace(/&[a-zA-Z0-9#]{0,};/g, '')
                    .replace(/[\n]{2,}/g, '\n')
                    .replace(/[ ]{2,}/gi, ' ')
                    .replace(/^ {1,}/gi, '')
                    .split('\n');

                utt.text = ttp.splice(0, 1);
                utt.lang = 'de-DE';
                utt.voice = speechSynthesis.getVoices()
                    .filter(e => e.lang === 'de-DE')[0];

                speechSynthesis.cancel();
                speechSynthesis.speak(utt);

                setIsSpeaking(true);
                setTextToPlay(ttp);
            } else if (isSpeaking && !isPaused) {
                speechSynthesis.cancel();
                setIsPaused(true);
                setIsSpeaking(false);
                setStarted(false);
            }
        } catch (error) {
            console.error(error);
            alert(error.message);
        }
    }

    if (isAbleToSpeak) {
        return (
            <a
                href={
                    !isPaused ? '#play' : '#pause'
                }
                onClick={toggleSpeaking}
                aria-label="Vorlesen"
                title={!isPaused ? 'Artikel vorlesen' : 'Pause'}>
                <Icon />
            </a>
        )
    }

    return null;
}


export default TtsButton;